import "./PragramCard.css";

import { ProgramCardProps, ProgramStatus } from "./ProgramCard.types";
import React, { useState } from "react";

const ApiUriSearch: string = process.env.REACT_APP_PROGRAM_SEARCH_API || "";
const ApiKeySearch: string = process.env.REACT_APP_PROGRAM_SEARCH_API_KEY || "";

const ProgramCard = (props: ProgramCardProps) => {
    const [expanded, setExpanded] = useState(false);
    const dateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };

    const getDegreeDisplay = () => {
        const degrees: string[] = [];
        if (props.program.degreeAssociate) {
            degrees.push("Associate");
        }
        if (props.program.degreeBaccalaureate) {
            degrees.push("Baccalaureate");
        }
        if (props.program.degreeCertificate) {
            degrees.push("Certificate");
        }
        if (props.program.degreeDiploma) {
            degrees.push("Diploma");
        }
        if (props.program.degreeMasters) {
            degrees.push("Masters");
        }
        return degrees;
    };

    return (
        <div className="result">
            <div className="result-container">
                <div className="result-header">
                    <div
                        className="title">
                        <span
                            onMouseEnter={() => setExpanded(true)}
                            onClick={() => setExpanded(!expanded)}>
                                                    {props.program.institutionName}
                            </span>
                    </div>
                    <div>
                        <button
                            className="icon-button"
                            onClick={() => setExpanded(!expanded)}
                        >
                            <span className="material-icons" style={{ fontSize: "36px" }}>
                                {expanded
                                    ? `remove_circle_outline`
                                    : `add_circle_outline`}
                            </span>
                        </button>
                    </div>
                </div>
                {props.program.programAddress && (
                    <>
                        <span className="material-icons place">place</span>
                        <div className="caption">
                            {`${props.program.programAddress.city}, ${props.program.programAddress.state} ${props.program.programAddress.country === 'United States of America' ?  'USA': props.program.programAddress.country}`}
                        </div>
                    </>
                )}
                        <div className="sub-title">
                            <div>
                                <div className="details-header">
                                    {props.program.professionName}
                                </div>
                                <div>
                                {props.program.programName && (
                                    <div className="details-sub-title">
                                        {props.program.programName}
                                    </div>
                                    )}
                                    {props.program.concentrationTitle && (
                                        <div>
                                        <span className="label">
                                            Concentration(s):&nbsp;
                                        </span>
                                            {props.program.concentrationTitle}
                                        </div>
                                    )}
                                    {props.program.addOnTracks.length > 0 && (
                                        <div>
                                        <span className="label">
                                        Add-on Track(s):&nbsp;
                                        </span>
                                            {props.program.addOnTracks.map(aot => aot.title).join(', ')}
                                        </div>
                                    )}
                                    {props.program.levelTitle && (
                                        <div>
                                        <span className="label">
                                            Level:&nbsp;
                                        </span>
                                            {props.program.levelTitle}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
            </div>
            {expanded ? (
                <>
                    {props.program.futureVoluntaryWithdraw && (
                        <div className="warning-message">
                            This program has requested voluntary withdrawal,
                            effective on{" "}
                            {new Date(
                                props.program.statusEffectiveDate
                            ).toDateString()}
                        </div>
                    )}
                    <div className="expandable-details">
                    {props.program.institutionWebsite && (
                    <div className="sub-title">
                        <a
                            target="_blank"
                            href={ props.program.institutionWebsite.indexOf( "http" ) >= 0 ? props.program.institutionWebsite : `http://${props.program.institutionWebsite}`} > View Institution </a></div>)}
                        <div className="details-row">
                            <div className="column">
                                <div className="details-header">
                                    Program Details
                                </div>
                                <div>
                                    <div>
                                        <span className="label">
                                            Status:&nbsp;
                                        </span>
                                        {ProgramStatus[props.program.statusId]}
                                    </div>
                                    {props.program.statusId != 11  && (
                                    <div>
                                        <span className="label">
                                            Initial Accreditation Date:&nbsp;
                                        </span>
                                        {new Date(
                                            props.program.accreditedOn
                                        ).toLocaleDateString(
                                            "en-US",
                                            dateOptions
                                        )}
                                    </div>
                                     )}
                                    <div>
                                        <span className="label">
                                            Award:&nbsp;
                                        </span>
                                        {getDegreeDisplay().map((dtype, i) => {
                                            if (
                                                i + 1 ===
                                                getDegreeDisplay().length
                                            ) {
                                                return (
                                                    <span key={i}>{dtype}</span>
                                                );
                                            } else if (i === 1) {
                                                return (
                                                    <span key={i}>
                                                        {dtype},<br />
                                                    </span>
                                                );
                                            } else {
                                                return (
                                                    <span key={i}>
                                                        {dtype},&nbsp;
                                                    </span>
                                                );
                                            }
                                        })}
                                    </div>
                                    {props.program.awardLetter && (
                                        <div className="link">
                                            <a
                                                target="_blank"
                                                href={`${ApiUriSearch}/api/${props.program.awardLetter.blobFolderProgramId || props.program.awardLetter.programId}/download-award-letter/${props.program.awardLetter.fileUrl}?code=${ApiKeySearch}`}
                                            >
                                                Decision Letter
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div>
                                <div className="details-header">
                                    Contact Information
                                </div>
                                {props.program.programDirector && (
                                    <div>
                                        <div>
                                            <span className="label">
                                                Program Director:&nbsp;
                                            </span>
                                            {`${props.program.programDirector.firstName} ${props.program.programDirector.lastName} ${props.program.programDirector.credentials}`}
                                        </div>
                                        <div>
                                            <span className="label">
                                                Phone:&nbsp;
                                            </span>
                                            {
                                                props.program.programDirector
                                                    .phone
                                            }
                                        </div>
                                        <div>
                                            <span className="label">
                                                Email:&nbsp;
                                            </span>
                                            <a
                                                href={`mailto:${props.program.programDirector.email}`}
                                            >
                                                {
                                                    props.program
                                                        .programDirector.email
                                                }
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div>
                                <div className="details-header">Address</div>
                                <div>
                                    {props.program.programAddress && (
                                        <>
                                            <div>
                                                {
                                                    props.program
                                                        .programAddress.address
                                                }
                                            </div>
                                            <div>
                                                {
                                                    props.program
                                                        .programAddress
                                                        .address2
                                                }
                                            </div>
                                            <div>{`${props.program.programAddress.city}, ${props.program.programAddress.state} ${props.program.programAddress.zip}`}</div>
                                            {props.program.programAddress.country != "United States of America" && (
                                             <div>{`${props.program.programAddress.country}`}</div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                            <div>
                                <div>
                                    {props.program.satellites.length > 0 && (
                                        <div
                                            className="tag"
                                            style={{ marginBottom: "12px" }}
                                        >
                                            Satellite Location(s)
                                        </div>
                                    )}
                                    <div>
                                        {props.program.satellites.map(
                                            (sat, index) => {
                                                if (
                                                    index + 1 ===
                                                    props.program.satellites
                                                        .length
                                                ) {
                                                    return `${sat.title} ${sat.city}, ${sat.state}`;
                                                } else {
                                                    return `${sat.title}: ${sat.city}, ${sat.state}, `;
                                                }
                                            }
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="program-details-footer">
                        <div className="visit-program-container">
                            <div>
                                {props.program.programWebsite && (
                                    <div className="ps-footer-link">
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={
                                                props.program.programWebsite.indexOf(
                                                    "http"
                                                ) >= 0
                                                    ? props.program
                                                          .programWebsite
                                                    : `http://${props.program.programWebsite}`
                                            }
                                        >
                                            Visit&nbsp;Program
                                        </a>
                                    </div>
                                )}
                                {props.program.outcomesUrl && (
                                    <div className="ps-footer-link">
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={
                                                props.program.outcomesUrl.indexOf(
                                                    "http"
                                                ) >= 0
                                                    ? props.program.outcomesUrl
                                                    : `http://${props.program.outcomesUrl}`
                                            }
                                        >
                                            Program&nbsp;Outcomes
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className={`result-tag-container`}>
                    <div className="cert">
                        {getDegreeDisplay().map((dtype, i) => {
                            if (i + 1 === getDegreeDisplay().length) {
                                return <span key={i}>{dtype}</span>;
                            } else {
                                return <span key={i}>{dtype},&nbsp;</span>;
                            }
                        })}
                    </div>
                    <div className="tag-container">
                        {props.program.distance && (
                            <div className="distance-tag">
                                Distance Education
                            </div>
                        )}
                        {props.program.satellites.length > 0 && (
                            <div className="tag">Satellite Location(s)</div>
                        )}
                        {props.program.addOnTracks.length > 0 && (
                            <div className="tag">Add-on Track(s)</div>
                        )}
                        {props.program.statusId === 10 && (
                            <div className="red-tag">Inactive</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProgramCard;
